/**
 * Product Bars Animation
 * Animates progress bars with spring animation when scrolled into view
 */

function initProductBarsAnimator() {
  if (customElements.get("product-bars-animator")) {
    return;
  }

  class ProductBarsAnimator extends HTMLElement {
    constructor() {
      super();
      this.animated = false;
    }

    connectedCallback() {
      this.bars = this.querySelectorAll(".product-bars__fill");
      this.init();
    }

    init() {
      // Wait for Motion to be available
      if (
        typeof Motion === "undefined" ||
        typeof Motion.animate !== "function"
      ) {
        setTimeout(() => this.init(), 50);
        return;
      }

      this.setupIntersectionObserver();
    }

    setupIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.2, // Trigger when 20% of the element is visible
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.animated) {
            this.animateBars();
            this.animated = true;
          }
        });
      }, options);

      this.observer.observe(this);
    }

    animateBars() {
      this.bars.forEach((bar, index) => {
        const targetWidth = parseFloat(bar.dataset.targetWidth);

        if (isNaN(targetWidth)) return;

        // Stagger the animations slightly for a nice effect
        setTimeout(() => {
          Motion.animate(
            bar,
            { width: `${targetWidth}%` },
            {
              duration: 1.2,
              easing: [0.34, 1.56, 0.64, 1], // Custom cubic-bezier for smooth bounce effect
            }
          );
        }, index * 100); // 100ms stagger between each bar
      });
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  customElements.define("product-bars-animator", ProductBarsAnimator);
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initProductBarsAnimator);
} else {
  initProductBarsAnimator();
}
